import FacilityId                       from "../../../domain/facility/FacilityId";
import FacilityRepository               from "../../../domain/facility/FacilityRepository";
import FacilityWebReservationTargetType from "../../../domain/facility/FacilityWebReservationTargetType";
import FetchStatusRepository            from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import ErrorRepository                  from "../../../domain/fundamentals/message/error/ErrorRepository";
import NotifyMessage                    from "../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyRepository                 from "../../../domain/fundamentals/message/notify/NotifyRepository";
import NotifyType                       from "../../../domain/fundamentals/message/notify/NotifyType";
import FetchStatusDataSource            from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import ErrorDataSource                  from "../../../infrastructure/datasource/error/ErrorDataSource";
import FacilityDataSource               from "../../../infrastructure/datasource/facility/FacilityDataSource";
import NotifyDataSource                 from "../../../infrastructure/datasource/notify/NotifyDataSource";
import GetFacilities                    from "./GetFacilities";

class UpdateFacilityTargetType {
  constructor(
    private readonly dispatch,
    private readonly facilityRepository: FacilityRepository = new FacilityDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch),
    private readonly getFacilities: GetFacilities = new GetFacilities(dispatch),
  ) {
  }

  public async execute(facilityId: FacilityId, targetType: FacilityWebReservationTargetType) {
    this.fetchStatusRepository.start();
    try {
      await this.facilityRepository.updateTargetType(facilityId, targetType);
      await this.getFacilities.execute();
      this.notifyRepository.optionalMessage(NotifyType.OPTIONAL_SUCCESS, new NotifyMessage("WEB予約対象を更新しました。"));
    } catch (e) {
      this.notifyRepository.optionalMessage(NotifyType.OPTIONAL_FAILURE, new NotifyMessage("WEB予約対象を更新できませんでした。"));
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default UpdateFacilityTargetType;
